import { memo } from "react";

import DisplayDraftBrainstormIdea, {
  DisplayDraftBrainstormIdeaProps
} from "./DisplayDraftBrainstormIdea";
import DisplayExperiment, { DisplayExperimentProps } from "./DisplayExperiment";
import DisplayIdea, { DisplayIdeaProps } from "./DisplayIdea";
import DisplayInsight, { DisplayInsightProps } from "./DisplayInsight";
import DisplayObjective, { DisplayObjectiveProps } from "./DisplayObjective";
import DisplayObservation, {
  DisplayObservationProps
} from "./DisplayObservation";
import DisplayBarChart, { DisplayBarChartProps } from "./ui/DisplayBarChart";
import DisplayPieChart, { DisplayPieChartProps } from "./ui/DisplayPieChart";

type DisplayInsight = {
  id: "tool-display_insight";
  data: DisplayInsightProps;
};

type DisplayExperiment = {
  id: "tool-display_experiment";
  data: DisplayExperimentProps;
};

type DisplayIdea = {
  id: "tool-display_idea";
  data: DisplayIdeaProps;
};

type DisplayObjective = {
  id: "tool-display_objective";
  data: DisplayObjectiveProps;
};

type DisplayObservation = {
  id: "tool-display_observation";
  data: DisplayObservationProps;
};

type DisplayDraftBrainstormIdea = {
  id: "tool-display_draft_brainstorm_idea";
  data: DisplayDraftBrainstormIdeaProps;
};

type DisplayPieChart = {
  id: "tool-display_pie_chart";
  data: DisplayPieChartProps;
};

type DisplayBarChart = {
  id: "tool-display_bar_chart";
  data: DisplayBarChartProps;
};

export type DisplayToolPayload =
  | DisplayInsight
  | DisplayExperiment
  | DisplayIdea
  | DisplayObjective
  | DisplayObservation
  | DisplayDraftBrainstormIdea
  | DisplayPieChart
  | DisplayBarChart;

const DisplayTool = (props: DisplayToolPayload) => {
  const { id, data } = props;

  switch (id) {
    case "tool-display_insight":
      return <DisplayInsight {...data} />;
    case "tool-display_experiment":
      return <DisplayExperiment {...data} />;
    case "tool-display_idea":
      return <DisplayIdea {...data} />;
    case "tool-display_objective":
      return <DisplayObjective {...data} />;
    case "tool-display_observation":
      return <DisplayObservation {...data} />;
    case "tool-display_draft_brainstorm_idea":
      return <DisplayDraftBrainstormIdea idea={data.idea} />;
    case "tool-display_pie_chart":
      return <DisplayPieChart {...data} />;
    case "tool-display_bar_chart":
      return <DisplayBarChart {...data} />;
    default:
      return null;
  }
};

export default memo(DisplayTool);
